var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMatrixCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.938 2.5C22.075 2.5 23 3.412 23 4.536v14.928c0 1.124-.924 2.036-2.063 2.036H3.063C1.925 21.5 1 20.588 1 19.464V4.536C1 3.412 1.924 2.5 3.063 2.5zM7.302 15.733H2.719v3.562c0 .28.232.509.515.509H7.76l-.001-3.56a5.963 5.963 0 01-.456-.511zm2.175 1.713v2.358h5.041v-2.356A5.987 5.987 0 0112 18a5.992 5.992 0 01-2.523-.554zm11.804-1.714h-4.583c-.142.18-.294.35-.456.512l-.001 3.56h5.04v-4.072zm-6.305-4.893H9.024a.29.29 0 00-.205.496l2.975 2.975a.29.29 0 00.412 0l2.975-2.975a.29.29 0 00-.205-.496zm-8.622-.875H2.719v4.072h3.635A5.972 5.972 0 016 12c0-.715.125-1.4.354-2.036zm14.927 0h-3.635c.23.636.354 1.321.354 2.036 0 .715-.125 1.4-.354 2.036h3.635V9.964zM7.76 4.196H3.234a.515.515 0 00-.515.51v3.562h4.583c.142-.18.294-.35.456-.512l.001-3.56zm13.522 0h-5.04l.001 3.56c.162.162.314.332.456.511h4.583v-4.07zm-6.763 0h-5.04v2.358A5.982 5.982 0 0112 6c.9 0 1.752.198 2.518.552V4.196z"
  }))));
}

export default SvgMatrixCaret;